import type { TooltipContent } from "@exopengithub/exokit";
import type { TablerIcon } from "@tabler/icons-react";
import type { ComponentProps } from "react";

export type SyncStatusTone = "neutral" | "attention" | "syncing";

export const syncStatusToneClassName: Record<SyncStatusTone, string> = {
	neutral: "text-grey-400",
	attention: "text-error-500",
	syncing: "text-warning-500",
};

export const syncStatusTooltipVariant: Record<
	SyncStatusTone,
	ComponentProps<typeof TooltipContent>["variant"]
> = {
	neutral: "dark",
	attention: "error",
	syncing: "warning",
};

export interface SyncStatusPresentation {
	tone: SyncStatusTone;
	Icon: TablerIcon;
	spin?: "smooth" | "stepped";
	word: string;
	phrase: string;
	timestamp: Date | null;
}
